
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface TouristTourFromDB {
  id: string;
  name_ar: string;
  name_en: string | null;
  description_ar: string | null;
  price: number | null;
  currency: string | null;
  vehicle_types: { name_ar: string } | null;
}

const fetchTouristTours = async (): Promise<TouristTourFromDB[]> => {
  const { data, error } = await supabase
    .from('tourist_tours')
    .select(`
      id,
      name_ar,
      name_en,
      description_ar,
      price,
      currency,
      vehicle_types(name_ar)
    `)
    .order('sort_order', { ascending: true });
  
  if (error) throw new Error(error.message);
  return data as TouristTourFromDB[];
};

export const useTouristTours = () => {
  return useQuery<TouristTourFromDB[]>({
    queryKey: ['tourist-tours-list'],
    queryFn: fetchTouristTours,
  });
};
